import React from 'react';
import { X, MessageCircle, ExternalLink } from 'lucide-react';
import { useTheme } from '../ThemeContext';

const ContactDialog = ({ isOpen, onClose }) => {
  const { theme } = useTheme();
  
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Backdrop with blur effect */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      />
      
      {/* Dialog */}
      <div className={`relative ${theme === 'dark' ? 'bg-gray-800 border border-gray-700' : 'bg-white'} rounded-xl shadow-2xl max-w-md w-full mx-4 p-6 transform transition-all`}>
        <div className="absolute top-3 right-3">
          <button 
            onClick={onClose}
            className={`p-2 rounded-full transition-colors ${theme === 'dark' ? 'hover:bg-gray-700 text-gray-400 hover:text-white' : 'hover:bg-gray-100 text-gray-500 hover:text-gray-900'}`}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>
        
        <div className="pt-1">
          <div className="flex flex-col items-center text-center mb-5">
            <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 ${theme === 'dark' ? 'bg-indigo-900/70' : 'bg-indigo-100'} shadow-lg`}>
              <MessageCircle size={32} className="text-indigo-600 dark:text-indigo-400" />
            </div>
            <h3 className="text-2xl font-bold mb-1">Contact Us</h3>
            <div className={`w-12 h-1 ${theme === 'dark' ? 'bg-indigo-500' : 'bg-indigo-600'} mb-4 rounded-full`}></div>
            
            <p className={`${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'} mb-2 max-w-sm`}>
              Thank you for your interest in RPFProtect!
            </p>
            <p className={`${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'} mb-5 max-w-sm`}>
              For questions or support, contact us directly on Discord:
            </p>
          </div>
          
          {/* Discord Button with subtle hover effect */}
          <a 
            href="https://discord.gg/Bw8u9SM49n" 
            target="_blank" 
            rel="noopener noreferrer"
            className={`flex items-center justify-center gap-2 py-3 px-5 rounded-lg font-medium text-white w-full transition-all transform hover:scale-[1.01] ${
              theme === 'dark' 
                ? 'bg-indigo-600 hover:bg-indigo-700' 
                : 'bg-indigo-600 hover:bg-indigo-700'
            } shadow-md hover:shadow-lg`}
          >
            <span>Join Our Discord Server</span>
            <ExternalLink size={16} />
          </a>
          
          {/* Additional support text */}
          <p className={`text-center mt-3 text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>
            We look forward to helping you secure your FiveM mods
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactDialog;